module.exports = __webpack_public_path__ + "static/media/loc04_GoldenCircle.192f6506.png";